var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg1DarkBullet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.53125,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0F0F0F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7138 7.27273V16H12.657V8.38068H12.6058L10.4751 9.79545V8.72159L12.657 7.27273H13.7138Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg1DarkBullet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/1-dark-bullet.2d529082.svg";
export { ForwardRef as ReactComponent };